export const MAX_NOTIFICATION_TIMES = 1;
